import { render } from "./OpenCalendar.vue?vue&type=template&id=b62f6a3e&scoped=true"
import script from "./OpenCalendar.vue?vue&type=script&lang=js"
export * from "./OpenCalendar.vue?vue&type=script&lang=js"

import "./OpenCalendar.vue?vue&type=style&index=0&id=b62f6a3e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\PC\\Documents\\RWI\\surefooted-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b62f6a3e"]])

export default __exports__